import IconBtn from './IconBtn';
import './styles/dialog.css';
import { motion, AnimatePresence } from 'framer-motion';
import { Capacitor } from '@capacitor/core';
import classNames from 'classnames';

type DialogProps = {
  title?: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  stackBackdropLayer?: boolean;
};

function Dialog(props: DialogProps) {
  const { title, open, onClose, children, stackBackdropLayer } = props;

  const isNative = Capacitor.isNativePlatform();

  const dialogContainerClass = classNames('dialog-container', {
    'dialog-safe-area': isNative,
  });

  const dialogBackdropClass = classNames('dialog-backdrop', {
    'safe-area-padding': isNative,
    '!z-50 !bg-black/10': stackBackdropLayer,
  });

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className={dialogBackdropClass}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0 } }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
        >
          <motion.div
            className={dialogContainerClass}
            initial={{ opacity: 1, y: 15 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 0.1 } }}
            exit={{ opacity: 0, transition: { duration: 0 } }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="dialog-header-row">
              {title && <h2 className="dialog-title">{title}</h2>}
              <span className="dialog-close-btn">
                <IconBtn icon="X" noBackground largeStrokeSize xl onClick={onClose} />
              </span>
            </div>
            <div className="dialog-content">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Dialog;
